import nurseryPhoto from '../assets/images/nursery.jpg';
import primaryPhoto from '../assets/images/primary.jpg';
import secondaryPhoto from '../assets/images/secondary.jpg';

/* `side` is which column the text card takes on desktop; the photo takes the
 * other one and the card's notched corner points back at the timeline. */
export const stages = [
  {
    id: 'toddler-room',
    eyebrow: 'Stage one',
    eyebrowClass: 'text-coral',
    ages: 'Ages 2–4',
    title: 'The Toddler Room',
    body: 'Two teachers, twelve toddlers, and a floor made for falling on. Days run on rhythm rather than timetable: singing, water play, story circle, a real nap, and outdoor time whatever the weather.',
    tags: ['Potty-training support', 'Daily photo diary', 'Hot lunch included'],
    linkLabel: 'See a Toddler day, hour by hour',
    photo: nurseryPhoto,
    photoAlt:
      'A teacher and eight toddlers around a low round table, tracing letter shapes with pebbles',
    side: 'left',
  },
  {
    id: 'primary',
    eyebrow: 'Stage two',
    eyebrowClass: 'text-forest',
    ages: 'Grades 1–5',
    title: 'Primary School',
    body: 'Reading, numbers and curiosity, taught in small groups by ability rather than age. Every child reads aloud to an adult daily, and every Friday afternoon belongs to a project of their own choosing.',
    tags: ['Daily reading 1-on-1', 'Two languages', 'Friday projects'],
    linkLabel: 'See the Primary curriculum',
    photo: primaryPhoto,
    photoAlt:
      'Primary pupils in checked-collar uniforms crowded around a classroom table watching a water experiment',
    side: 'right',
  },
  {
    id: 'secondary',
    eyebrow: 'Stage three',
    eyebrowClass: 'text-sun-deep',
    ages: 'Grades 6–10',
    title: 'Secondary School',
    body: 'Serious subject teaching without losing the warmth. Science labs, a workshop, competitive sport, and a named mentor who follows each student from Grade 6 to graduation.',
    tags: ['Science & tech labs', 'One mentor, five years', 'Exam prep from Gr 8'],
    linkLabel: 'See subjects & results',
    photo: secondaryPhoto,
    photoAlt: 'Four secondary students reading together at a library table',
    side: 'left',
  },
];
